function togglePhonenumberContent(item) {
  const dropdownContent = item.querySelector('.dropdown-content');
  dropdownContent.classList.toggle('dropdown-content__open');
}

function rotateArrow(item) {
  const dropdownArrow = item.querySelector('.dropdown_arrow');
  dropdownArrow.classList.toggle('chevron-down');
}

export default function phoneToggle() {
  const roots = document.querySelectorAll('.dropdown');
  if (!roots) {
    return null;
  }
  // eslint-disable-next-line consistent-return
  [...roots].forEach((root) => {
    const item = root.querySelector('.dropbtn');
    if (!item) {
      return null;
    }
    item.addEventListener('click', (e) => {
      e.preventDefault();
      togglePhonenumberContent(root);
      rotateArrow(root);
    });
  });
  return true;
}
